<template>
    <div>
        <b-row>
            <b-col sm="12">
                <h5 class="heading-1">
                    <span>Empresas Atendidas</span>
                </h5>
                <app-tabela
                    idTabela="tblRahtEmpresas"
                    :itens="empresas"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                    :mostrarFiltro="false"
                >
                    <template slot="botoes">
                        <btn-inserir-raht-empresa
                            class="mt-1 mb-3"
                            @inserirEmpresa="inserirEmpresa($event)"
                            v-if="edicaoHabilitada"
                        ></btn-inserir-raht-empresa>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="documento" slot-scope="data">
                        <span
                            v-if="
                                data.tipoDocumento == 'CPF' ||
                                    data.tipoDocumento == 'CNPJ'
                            "
                            >{{ data.documento | toCpfCnpj }}</span
                        >
                        <span v-if="data.tipoDocumento == 'DAP'">{{
                            data.documento
                        }}</span>
                        <span v-if="data.tipoDocumento == 'NIRF'">{{
                            data.documento | toNirf
                        }}</span>
                        <span v-if="data.tipoDocumento == 'SICAB'">{{
                            data.documento | toSicab
                        }}</span>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <btn-atualizar-raht-empresa
                            :empresa="data"
                            @atualizarEmpresa="atualizarEmpresa($event)"
                        >
                        </btn-atualizar-raht-empresa>
                        <btn-excluir-raht-empresa
                            :empresa="data"
                            @excluirEmpresa="$emit('excluirEmpresa', data)"
                        >
                        </btn-excluir-raht-empresa>
                        <slot name="acoes" v-bind="data"></slot>
                    </template>
                </app-tabela>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import BtnInserirRahtEmpresa from './BtnInserirRahtEmpresa'
import BtnAtualizarRahtEmpresa from './BtnAtualizarRahtEmpresa'
import BtnExcluirRahtEmpresa from './BtnExcluirRahtEmpresa'

export default {
    components: {
        BtnInserirRahtEmpresa,
        BtnAtualizarRahtEmpresa,
        BtnExcluirRahtEmpresa
    },

    props: {
        raht: {
            type: Object,
            default: () => ({})
        },

        empresas: {
            type: Array,
            default: () => []
        },

        edicaoHabilitada: {
            type: Boolean,
            default: () => true
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'nome',
                    label: 'Nome',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'tipoDocumento',
                    label: 'Tipo Documento',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'documento',
                    label: 'Documento',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'qtdHoras',
                    label: 'Qtd de Horas',
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        inserirEmpresa(empresa) {
            if (
                this.empresas.filter(r => {
                    return (
                        r.documento == empresa.documento ||
                        r.nome.toUpperCase() == empresa.nome.toUpperCase()
                    )
                }).length > 0
            ) {
                this.erroNaEmpresa('I')
            } else {
                this.$emit('inserirEmpresa', empresa)
            }
        },

        atualizarEmpresa(empresa) {
            if (
                this.empresas
                    .filter(r => {
                        return r.documento != empresa.documento
                    })
                    .every(r => r.nome != empresa.nome)
            ) {
                this.$emit('atualizarEmpresa', empresa)
            } else {
                this.erroNaEmpresa('A')
            }
        },

        erroNaEmpresa(tipo) {
            let msg
            if (tipo == 'I') {
                msg = `Já existe empresa com o documento ou nome informados`
            } else {
                msg = `Já existe empresa com o nome informado`
            }
            this.$swal({
                title: 'Empresa atendida',
                html: msg,
                icon: 'error'
            })
        },

        ajustarTabela() {
            if (!this.edicaoHabilitada) {
                this.campos.pop()
            }
        }
    },

    computed: {},

    created() {
        this.ajustarTabela()
    },

    watch: {
        edicaoHabilitada() {
            this.ajustarTabela()
        }
    }
}
</script>
